import { NAV_LINKS, LOGO_URL } from '@/lib/constants';
import { useContentValue } from '@/contexts/SiteContentContext';

export default function Footer() {
  const c = useContentValue();
  return (
    <footer data-testid="footer" className="border-t border-white/5 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src={LOGO_URL}
              alt="TreffPunkt Kaffee-Bar Luzern – Logo"
              className="h-20 w-auto object-contain"
            />
          </div>

          {/* Links */}
          <div className="flex items-center gap-6">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`footer-link-${link.label.toLowerCase()}`}
                className="text-stone-500 hover:text-amber-400 transition-colors text-xs tracking-wide uppercase font-body"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Social placeholder */}
          <div className="flex items-center gap-4">
            <a
              href="#"
              data-testid="footer-social-instagram"
              className="w-9 h-9 rounded-full glass-card flex items-center justify-center text-stone-400 hover:text-amber-400 hover:border-amber-400/30 transition-all duration-300"
              aria-label="Instagram"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
              </svg>
            </a>
            <a
              href="#"
              data-testid="footer-social-facebook"
              className="w-9 h-9 rounded-full glass-card flex items-center justify-center text-stone-400 hover:text-amber-400 hover:border-amber-400/30 transition-all duration-300"
              aria-label="Facebook"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </a>
          </div>
        </div>

        <div className="section-divider mt-8 mb-6" />

        <p className="text-center text-stone-600 text-xs font-body">
          &copy; {new Date().getFullYear()} TreffPunkt Café-Bar. Alle Rechte vorbehalten.
          &nbsp;&middot;&nbsp; {c('Footer.Copyright', 'Demo Website')}
        </p>
      </div>
    </footer>
  );
}
